export default "__VITE_ASSET__CgWtO6ca__"